import { axiosGet, axiosPost } from "../../../../../react_axios/Axios";
import { INSERT_AND_UPDATE_PHOTOGRAPHY_AND_VIDEOGRAPHY_ACTION_TYPE, GET_PHOTOGRAPHY_AND_VIDEOGRAPHY_DETAILS_ACTION_TYPE, headers, getPhotographyAndVideographyDetailsUrl, insertUpdatePhotographyAndVideographyUrl } from "../../../../../utils/constants";

export const insertUpdatePhotographyAndVideography_action =
  (
    PhotographyAndVideographyFormID,
    IsRequiredPhotographyAndVideography,
    Remark,
    IsAgree,
    ManualFormID,
    ServiceID,
    VendorDetails,
    StatusID,
    IsInvoicePaid
  ) =>
  async (dispatch) => {
    try {
      const params = {
        UserID: JSON.parse(sessionStorage.getItem("loginDataSS")).UserID,
        ExhibitionID: sessionStorage.getItem("sessionExhibitionID"),
        ExhRegistrationID: sessionStorage.getItem("ExhRegistrationIDSS"),
        PhotographyAndVideographyFormID: PhotographyAndVideographyFormID != "" ? PhotographyAndVideographyFormID : null,
        IsRequiredPhotographyAndVideography: IsRequiredPhotographyAndVideography,
        Remark: Remark,
        IsAgree: IsAgree,
        ManualFormID: ManualFormID,
        ServiceID: ServiceID,
        VendorDetails: VendorDetails,
        StatusID: StatusID || 0,
        IsInvoicePaid: IsInvoicePaid || false,
      };
      const res = await axiosPost(insertUpdatePhotographyAndVideographyUrl, params, headers);

      dispatch({
        type: INSERT_AND_UPDATE_PHOTOGRAPHY_AND_VIDEOGRAPHY_ACTION_TYPE,
        payload: res,
      });
      return Promise.resolve(res);
    } catch (error) {
      return Promise.reject(error);
    }
  };

export const getPhotographyAndVideographyDetails_action = () => async (dispatch) => {
  try {
    const params = {
      UserID: JSON.parse(sessionStorage.getItem("loginDataSS")).UserID,
      ExhibitionID: sessionStorage.getItem("sessionExhibitionID"),
      ExhRegistrationID: sessionStorage.getItem("ExhRegistrationIDSS"),
    };
    const res = await axiosGet(getPhotographyAndVideographyDetailsUrl, params, headers);

    dispatch({
      type: GET_PHOTOGRAPHY_AND_VIDEOGRAPHY_DETAILS_ACTION_TYPE,
      payload: res,
    });
    return Promise.resolve(res);
  } catch (error) {
    return Promise.reject(error);
  }
};
